<template>
  <div class="event-wrap">
    <div class="btn-content">
      <el-button
        icon="el-icon-plus"
        type="primary"
        @click="setMeasureAlbumCover"
        >设为封面</el-button
      >
      <el-button icon="el-icon-plus" type="primary" @click="addPhotoForMeasure"
        >添加图片</el-button
      >
      <el-button
        icon="el-icon-minus"
        type="primary"
        @click="removePhotoForMeasure"
        >删除图片</el-button
      >
    </div>
    <div class="imgBox" v-loading="showLoad">
      <div
        v-for="(item, index) in imgData"
        :key="index"
        class="table-content"
        :class="{ 'left-show': index == mouseIndex }"
        @click="selectImg($event, item, index)"
      >
        <i class="el-icon-s-claim fl" v-if="showFm == index">封面</i>
        <div
          class="el-icon-zoom-in fm"
          @click.stop="look(item.fileInfo.fileData, item, index)"
        >
          <span>放大图片</span>
          <viewer
            :images="[item.fileInfo.fileData]"
            style="
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              opacity: 0;
            "
          >
            <img
              v-for="src in [item.fileInfo.fileData]"
              :src="src"
              :key="src"
            />
          </viewer>
        </div>
        <div class="boxNew">
          <img
            class="smallImg"
            :src="item.fileInfo.fileData"
            @mouseenter="entry(index)"
            @mouseleave="leave(index)"
          />
          <!--<vue-viewer style="display: inline-block"-->
          <!--:thumb="urlList[0]"-->
          <!--:full="urlList[0]">-->
          <!--</vue-viewer>-->
          <!--<image-viewer-->
          <!--v-if="showBigImg"-->
          <!--:on-close="closeViewer"-->
          <!--:url-list="urlList"-->
          <!--z-index="2010"-->
          <!--/>-->
        </div>
        <p class="title">{{ item.fileInfo.fileName }}</p>
        <p class="title">{{ item.fileInfo.remark }}</p>
        <p class="title">{{ item.fileInfo.uploadingTime }}</p>
        <p class="title">{{ item.fileInfo.uploaderNickname }}</p>
      </div>
    </div>

    <!-- 新增图片 -->
    <el-dialog
      title="新增图片"
      :visible.sync="showImg"
      width="800px"
      :close-on-click-modal="false"
      :modal="false"
      @close="closeClass"
    >
      <el-form
        ref="imgForm"
        :model="imgForm"
        label-width="140px"
        :rules="rules"
      >
        <el-form-item label="选择图片" class="logoPage">
          <div class="el-form-item__content el-form-item-content">
            <img :src="imgPath" class="img-avatar" />
            <!-- name="company_logo" -->
            <input
              type="file"
              value="浏览"
              name="company_logo"
              accept="image/gif, image/jpeg, image/jpg, image/png"
              @change="changeImage($event)"
              ref="avatarInput"
              class="uppic"
            />
            <p class="imgNote">
              支持格式：.JPG .JPEG .PNG .BMP 格式，图片不能超过10MB
            </p>
          </div>
        </el-form-item>
        <el-form-item label="是否设为封面">
          <el-switch v-model="imgForm.isCover"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveMsgInfo">确 定</el-button>
        <el-button @click="showImg = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
//import imageViewer from "@/components/common/IeImageViewer";
import { EVEN } from "@/config/data";
export default {
  components: {
    // imageViewer,
  },
  data() {
    return {
      editMsgIndex: -1,
      mouseIndex: -1,
      showFm: 0,
      showImg: false,
      showBigImg: false,
      imgData: [],
      imgForm: {
        fileId: "",
        isCover: false,
      },
      rules: {
        isCover: [
          { required: true, message: "不能为空", trigger: ["blur", "change"] },
        ],
      },
      selectData: [],
      selecrRow: {},
      urlList: [],
      urlRow: {},
      urlIndex: "",
      showViewer: false,
      clicked: false,
      showLoad: false,
      showFr: -1,
      imgPath: "", //图片路径
      imgsForm: {
        fileName: "", //文件名
        remeark: "", //备注
        shard: -1, //不共享
        fileType: 1, //文件类型
        data: "",
      },
    };
  },
  props: {
    measureId: {
      type: String,
      default: "",
    },
    templateId: {
      type: String,
      default: "",
    },
  },
  watch: {
    measureId(val) {
      if (val && val.length > 0) {
        this.measureId = val;
        this.getData(val);
      }
    },
  },
  created() {
    console.log("上传图片");
    this.getData(this.measureId);
  },
  methods: {
    //上传图片
    changeImage(e) {
      let vm = this;
      var file = e.target.files[0];
      var reader = new FileReader();
      vm.imgsForm.fileName = file.name;
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        vm.imgPath = e.target.result;
        vm.imgsForm.data = e.target.result.split(",")[1];
      };
    },
    closeViewer() {
      this.showBigImg = false;
    },
    look(url, row, index) {
      this.showBigImg = true;
      this.urlList = [url];
    },
    getData(id) {
      let vm = this;
      let apiArr = [];
      vm.selectRow = {};
      vm.mouseIndex = null;
      vm.showLoad = true;
      apiArr.push(
        vm.$api.measure.listPhotosOfMeasure(id) //获取测量点相册
      );
      apiArr.push(
        vm.$api.measure.getMeasureAlbumCover(id) //获取封面数据
      );
      apiArr.push(
        vm.$api.file.getCompanyFilesInfo(0, 0, 100) //获取新增文件数据
      );
      Promise.all(apiArr).then((res) => {
        if (res[0].success && res[1].success) {
          res[0].data.forEach((item, index) => {
            item.fileInfo.fileData = vm.pullSmallFile(item.fileInfo.id, item); //转化base64
            if (
              res[1].data.fileInfo.id == item.fileInfo.id &&
              item.isCover == 1
            ) {
              //设置封面
              item.fileInfo.fileData = res[1].data.fileInfo.fileData;
              vm.showFm = index;
            }
          });
          vm.imgData = res[0].data;
          vm.showLoad = false;
        } else {
          if (!res[0].success) {
            vm.$message.error(res[0].msg);
          } else {
            vm.$message.error(res[1].msg);
          }
        }
        vm.selectData = res[2].data;
      });
    },
    pullSmallFile(id, item) {
      let vm = this;
      vm.$api.file.pullCompanySmallFile(id).then((res) => {
        return (item.fileInfo.fileData =
          "data:image/png;base64," + res.data.data);
      });
    },
    addPhotoForMeasure() {
      let vm = this;
      vm.imgForm.isCover = false;
      vm.imgPath = "";
      vm.showImg = true;
    },
    //保存新增
    saveMsgInfo() {
      let vm = this;
      vm.$api.file
        .pushCompanyFileToOss(
          0,
          vm.imgsForm.fileName,
          vm.imgsForm.remeark,
          vm.imgsForm.fileType,
          vm.imgsForm.data
        )
        .then((res1) => {
          let isCover = "0";
          if (vm.imgForm.isCover) {
            isCover = "1";
          }
          vm.$api.measure
            .addPhotoForMeasure(vm.measureId, res1.data.id, isCover)
            .then((res) => {
              if (res.success) {
                vm.$message({
                  message: "新增成功",
                  type: "success",
                });
                vm.getData(vm.measureId);
                vm.showImg = false;
              } else {
                vm.$message.error(res.msg);
              }
            });
        });
    },
    //选择图片
    selectImg(e, row, index) {
      let eventTwo = e.srcElement.className;
      if (
        eventTwo != "el-icon-circle-close" &&
        eventTwo != "el-image-viewer__mask"
      ) {
        //当不是放大标签点击事件
        this.selectRow = JSON.parse(JSON.stringify(row));
        this.mouseIndex = index;
      }
    },
    //移除图片
    removePhotoForMeasure() {
      let vm = this;
      if (Object.keys(vm.selectRow).length == 0) {
        vm.$message({
          message: "请选择图片删除",
          type: "warning",
        });
        return;
      }
      vm.$confirm("此操作将删除该图片, 是否继续?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          vm.$api.measure.removePhotoForMeasure(vm.selectRow.id).then((res) => {
            if (res.success) {
              vm.$message({
                message: "删除成功",
                type: "success",
              });
              vm.getData(vm.measureId);
            } else {
              vm.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    //设置封面
    setMeasureAlbumCover() {
      let vm = this;
      vm.showLoad = true;
      if (Object.keys(vm.selectRow).length == 0) {
        vm.$message({
          message: "请选择图片设置封面",
          type: "warning",
        });
        return;
      }
      vm.$api.measure.setMeasureAlbumCover(vm.selectRow.id).then((res) => {
        if (res.success) {
          vm.$message({
            message: "设置成功",
            type: "success",
          });
          vm.getData(vm.measureId);
          vm.showImg = false;
        } else {
          vm.$message.error(res.msg);
        }
      });
    },
    //关闭弹窗
    closeClass() {
      this.$refs["imgForm"].resetFields();
    },
    //鼠标移入事件
    entry(index) {
      this.showFr = index;
    },
    //鼠标移除事件
    leave(index) {
      this.showFr = -1;
    },
  },
};
</script>

<style lang="scss" scoped>
.event-wrap {
  width: 100%;
  padding: 0px 10px;
  box-sizing: border-box;
  height: 100%;
}

.boxNew {
  position: relative;
}
.titleBox {
  position: relative;
  height: 28px;
}
.fm {
  position: absolute;
  right: 8px;
  top: 8px;
  z-index: 1000;
  font-size: 17px;
  color: #169bd5;
  font-weight: 600;
  cursor: pointer;
  opacity: 0;
}
.fm:hover {
  opacity: 1;
}
.fl {
  position: absolute;
  left: 8px;
  top: 8px;
  z-index: 1000;
  font-size: 17px;
  color: #169bd5;
  font-weight: 600;
}
.btn-content {
  text-align: left;
  padding-bottom: 10px;
}
.imgBox {
  display: flex;
  flex-wrap: wrap;
  height: calc(100% - 50px);
  overflow: auto;
}
.table-content {
  display: flex;
  flex-flow: column;
  width: 210px;
  margin: 8px;
  cursor: pointer;
  border: 1px solid #ccd7e8;
  border-radius: 4px;
  height: 285px;
  position: relative;
}
.left-show {
  box-shadow: 0 0 10px 2px #ccd7e8;
  border: 1px solid #ccd7e8;
  border-radius: 4px;
}
.title {
  text-align: center;
  font-size: 14px;
  margin: 0;
  margin-bottom: 5px;
  margin-left: 5px;
  width: 205px;
  word-break: break-all;
  white-space: break-spaces;
}
.smallImg {
  width: 208px;
  height: 190px;
  padding-left: 1px;
  box-sizing: border-box;
}
</style>
<style lang="scss">
.event-wrap {
  text-align: left;
  .el-dialog__header {
    text-align: left;
  }
  .el-dialog__footer {
    text-align: center;
  }
  .el-dialog__body {
    padding: 20px;
  }
}
.logoPage {
  margin-bottom: 0 !important;
  position: relative;
}
.img-avatar {
  width: 200px;
  margin-right: 10px;
}
</style>